// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"444":"35ba93cf0b59ea03","708":"9b865862f045c1a7","930":"561419ae0b0c7996"}[chunkId] + ".js";
};